import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M16.176 12c0 1.043-1.869 3.652-4.174 3.652S7.828 13.043 7.828 12a4.174 4.174 0 1 1 8.348 0"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0052B4",
  d: "M16.176 12a4.174 4.174 0 1 1-8.348 0"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "m17.533 14.583-1.107 1.107.738.737 1.106-1.107zM15.689 16.427l-1.107 1.107.738.738 1.107-1.107zM19.747 16.795 18.641 17.9l.738.738 1.106-1.107zM17.904 18.64l-1.107 1.108.738.737 1.107-1.106zM18.642 15.69l-1.107 1.106.738.738 1.107-1.107zM16.794 17.534l-1.107 1.107.738.738 1.107-1.107zM15.69 5.358l2.95 2.952.738-.738-2.95-2.952zM14.585 6.466l1.106 1.107.738-.738-1.106-1.107zM16.428 8.31l1.107 1.107.738-.738-1.107-1.107zM16.796 4.252l1.106 1.107.738-.738-1.107-1.106zM18.64 6.098l1.106 1.106.738-.737-1.107-1.107zM7.205 19.748l-2.951-2.951-.738.738 2.951 2.95zM8.31 18.64l-1.107-1.107-.738.738 1.107 1.107zM6.466 16.796 5.36 15.689l-.737.738 1.106 1.107zM9.416 17.534l-2.951-2.952-.738.738 2.951 2.951zM4.252 7.205l2.951-2.952-.738-.737-2.951 2.95zM5.357 8.31 8.31 5.358l-.738-.737-2.952 2.95zM6.467 9.417l2.951-2.951-.738-.738L5.73 8.679z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }